"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ShuttleIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ShuttleIcon, _PureComponent);

  function ShuttleIcon() {
    _classCallCheck(this, ShuttleIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShuttleIcon).apply(this, arguments));
  }

  _createClass(ShuttleIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 20",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        style: {
          opacity: .3
        },
        d: "M3 14h.8a2.92 2.92 0 0 1 4.4 0h7.6a2.92 2.92 0 0 1 4.4 0h.8v-2.9l-7.2-.1V6.8H3z"
      }), _react2.default.createElement("path", {
        d: "M17 5H3a2.006 2.006 0 0 0-2 2v9h2a2.946 2.946 0 0 0 3 3 2.946 2.946 0 0 0 3-3h6a3 3 0 0 0 6 0h2v-5zm-2 2h1l3 3h-4zM6 17.3a1.216 1.216 0 0 1-1.2-1.2A1.29 1.29 0 0 1 6 14.9a1.29 1.29 0 0 1 1.2 1.2A1.216 1.216 0 0 1 6 17.3zm12 0a1.216 1.216 0 0 1-1.2-1.2 1.2 1.2 0 0 1 2.4 0 1.216 1.216 0 0 1-1.2 1.2zm3-3.3h-.8a2.92 2.92 0 0 0-4.4 0H8.2A3.029 3.029 0 0 0 6 13a2.865 2.865 0 0 0-2.2 1H3V7h9.9v5H21z"
      }));
    }
  }]);

  return ShuttleIcon;
}(_react.PureComponent);

exports.default = ShuttleIcon;